import { Heart } from "lucide-react";
import { imgSrc } from "@/lib/api";
import { useStoryRing } from "@/lib/storyRings";

const HEART = "M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z";
const FLOAT = [[6, 14, 0, 7.5, "text-white"], [16, 22, 2.6, 9, "text-amber-200"], [28, 12, 1.2, 8, "text-pink-100"], [41, 18, 4.1, 10, "text-white"], [53, 10, 0.6, 7, "text-rose-200"], [64, 24, 3.2, 9.5, "text-amber-100"], [75, 14, 1.8, 8.5, "text-white"], [86, 20, 4.8, 10, "text-pink-100"], [94, 11, 2.2, 7.5, "text-amber-200"]];

export function FloatingHearts() {
  return (
    <div className="absolute inset-0 overflow-hidden pointer-events-none" aria-hidden data-testid="supporter-floating-hearts">
      {FLOAT.map(([x, s, d, dur, c], i) => (
        <Heart key={i} className={`absolute bottom-[-24px] sp-float-heart ${c}`} fill="currentColor" strokeWidth={0}
          style={{ left: `${x}%`, width: s, height: s, animationDelay: `${d}s`, animationDuration: `${dur}s` }} />
      ))}
    </div>
  );
}

export function HeartFrameAvatar({ p }) {
  const story = useStoryRing(p.user_id);
  return (
    <div className="relative shrink-0 w-[176px] h-[176px] sm:w-[212px] sm:h-[212px]" data-testid="supporter-avatar-frame">
      <span className="absolute inset-4 rounded-full bg-rose-300/40 blur-2xl" aria-hidden />
      <svg viewBox="0 0 24 24" className="absolute inset-0 w-full h-full sp-heart-frame" aria-hidden>
        <defs>
          <linearGradient id="sp-frame" x1="0" y1="0" x2="1" y2="1"><stop offset="0" stopColor="#f9a8c9" /><stop offset=".45" stopColor="#ec4899" /><stop offset=".75" stopColor="#e6b85c" /><stop offset="1" stopColor="#fbe7a8" /></linearGradient>
        </defs>
        <path d={HEART} fill="url(#sp-frame)" />
        <path d={HEART} fill="none" stroke="#fff" strokeOpacity=".75" strokeWidth=".35" />
      </svg>
      <div onClick={story ? story.open : undefined} role={story ? "button" : undefined} data-testid={story ? `story-ring-${p.user_id}` : `vip-frame-${p.user_id}`} data-seen={story ? String(story.seen) : undefined}
        className={`absolute left-[16.6%] top-[12.5%] w-[66.8%] h-[66.8%] rounded-full p-[3px] ${story ? `cursor-pointer ${story.seen ? "bg-slate-300" : "story-ring"}` : "bg-white"} shadow-[0_10px_24px_-10px_rgba(157,20,70,.6)]`}>
        <div className="w-full h-full rounded-full overflow-hidden bg-rose-50 ring-2 ring-white" data-testid="supporter-avatar-image">
          {p.picture ? <img src={imgSrc(p.picture)} alt={p.name} className="w-full h-full object-cover" />
            : <div className="w-full h-full flex items-center justify-center font-display text-5xl font-extrabold text-rose-500">{p.name?.[0]?.toUpperCase()}</div>}
        </div>
      </div>
      <span className="absolute right-[13%] bottom-[22%] w-9 h-9 rounded-full bg-white shadow-md ring-2 ring-amber-200 flex items-center justify-center sp-heart-badge" aria-hidden><Heart className="w-[18px] h-[18px] text-rose-500" fill="currentColor" /></span>
    </div>
  );
}
